import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { StatsigProvider } from '@americanexpress/react-statsig-wrapper';
import isStatSigEnabled from '../utils/isStatsigEnabled';
import { getEnvironment } from '../utils/getEnvironment';

const Statsig = ({ locale, children, localeFilename }) => {
  const environment = getEnvironment({
    localeFilename,
  });
  if (isStatSigEnabled({ locale })) {
    return (
      <StatsigProvider
        clientKey="client-z2rWYCeBZehdOO3QqP2XbI9Sr2ApdE4VIMgJ2GgClIS"
        options={{
          environment: {
            tier: environment,
          },
        }}
      >
        {children}
      </StatsigProvider>
    );
  }
  return children;
};

export const mapStateToProps = (state) => ({
  localeFilename: state.getIn(['config', 'localeFilename']),
});

Statsig.propTypes = {
  locale: PropTypes.string,
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
  ]).isRequired,
  localeFilename: PropTypes.string,
};

export default connect(mapStateToProps)(Statsig);
